module.exports = __webpack_public_path__ + "img/box.f5d74e9f.png";